/**
 * @generated SignedSource<<7fc6e5d7b4e904f7369b0ce7151a8de6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionNewsletterWidgetQuery$data = {
  readonly section: {
    readonly entityId: string;
  };
  readonly " $fragmentType": "sectionNewsletterWidgetQuery";
};
export type sectionNewsletterWidgetQuery$key = {
  readonly " $data"?: sectionNewsletterWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionNewsletterWidgetQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionNewsletterWidgetQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityId",
              "variableName": "entityId"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "39e6e3f9ef61b2ea1836da186db98070";

export default node;
